(() => {
  const root = document.querySelector('[data-delivery-plan]');
  if (!root || !globalThis.ElternAnkerDelivery) return;
  const dates = new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', { day: '2-digit', month: '2-digit', timeZone: 'UTC' });
  const countdown = root.querySelector('[data-delivery-countdown]');
  const dispatch = root.querySelector('[data-delivery-dispatch]');
  const range = root.querySelector('[data-delivery-range]');

  function update() {
    if (document.hidden) return;
    const estimate = globalThis.ElternAnkerDelivery.estimate();
    const hours = Math.floor(estimate.remainingSeconds / 3600);
    const minutes = Math.floor(estimate.remainingSeconds / 60) % 60;
    const seconds = estimate.remainingSeconds % 60;
    countdown.textContent = [hours, minutes, seconds].map(value => String(value).padStart(2, '0')).join(':');
    countdown.setAttribute('aria-label', `${hours} ${root.dataset.hours} ${minutes} ${root.dataset.minutes} ${seconds} ${root.dataset.seconds}`);
    dispatch.textContent = dates.format(estimate.dispatchDate);
    range.textContent = `${dates.format(estimate.deliveryMin)} – ${dates.format(estimate.deliveryMax)}`;
    root.querySelector('[data-delivery-fallback]').hidden = true;
    root.querySelector('[data-delivery-steps]').hidden = false;
    root.querySelector('[data-delivery-note]').hidden = false;
  }

  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  window.addEventListener('pageshow', update);
})();
